import { render, staticRenderFns } from "./effective_device.vue?vue&type=template&id=2828cc54&"
import script from "./effective_device.vue?vue&type=script&lang=js&"
export * from "./effective_device.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports